import * as React from 'react';

function SvgToggle2Off(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M9 11c.628-.836 1-1.874 1-3a4.978 4.978 0 00-1-3h4a3 3 0 110 6H9z' />
			<path d='M5 12a4 4 0 110-8 4 4 0 010 8zm0 1A5 5 0 105 3a5 5 0 000 10z' />
		</svg>
	);
}

export default SvgToggle2Off;
